export default "__VITE_ASSET__uEkhNOGM__"